import Hls from 'hls.js';

(function () {
  const videos = document.querySelectorAll('.cg-video video');
  const approveBtns = document.querySelectorAll('.cg-video button');

  videos && videos.forEach((video) => {
    const hls = new Hls();

    if (Hls.isSupported() && video.src) {
      hls.loadSource(video.src);
      hls.attachMedia(video);
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = video.src;
    }
  });

  approveBtns && approveBtns.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();

      const videoWrapper = event.target.closest('.cg-video');
      const video = videoWrapper.querySelector('video');
      const overlay = videoWrapper.querySelector('.cg-video__overlay');
      const demoLength = video.dataset.demoLength ?? 600000;

      video.play();
      overlay.classList.add('transparent');

      setTimeout(() => {
        video.pause();
        overlay.classList.remove('transparent');
        overlay.classList.add('has-cta');
      }, demoLength * 1000);
    });
  });
})();